<!-- <app-component-tasks-table
        [colons]="widgetData.content?.colons"
        [tasks]="widgetData.content?.data"
        [isSubtasks]="true"
        [tasks]="widgetData.content.data"
></app-component-tasks-table>
<app-component-pagination
        *ngIf="widgetData.content?.page_count > 1"
        [totalPages]="widgetData?.content.page_count"
        [pagination]="{
                        pages: widgetData.content?.page_count,
                        current_page: widgetData?.content.current_page,
                        limit: 20
                    }"
        (page)="changePage($event, widgetData)"
></app-component-pagination> -->
<app-tasks-table-mt
        [customColumns]="widgetData.content?.colons"
        [headerTransparent]="true"
        [onlyTable]="true"
        [rowsPerPages]="20"
        [tasksData]="widgetData.content?.data"
        [widgetView]="true"
></app-tasks-table-mt>
